import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import {
  AccountSectionsActionTypes,
  LoadSectionsSuccess,
  LoadSectionsFailure,
} from './account-sections.actions';
import { map, catchError, switchMap } from 'rxjs/operators';
import { AccountSectionsService } from '@account-users/account/services/account-sections.service';
import { ISectionMap } from '@account-users/account/models/Audience';

@Injectable()
export class AccountSectionsEffects {
  @Effect()
  loadSections$ = this.actions$.pipe(
    ofType(AccountSectionsActionTypes.LoadSections),
    switchMap(({ payload }) => {
      const { accountId, filters } = payload;
      return this.accountSectionsService.fetchSections(accountId, filters).pipe(
        map((response: ISectionMap) => {
          return new LoadSectionsSuccess(response);
        }),
        catchError((error) => {
          this.toastr.error('Could not fetch sections', 'Request failed');
          return [new LoadSectionsFailure()];
        }),
      );
    }),
  );

  constructor(
    private toastr: ToastrService,
    private actions$: Actions,
    private accountSectionsService: AccountSectionsService,
  ) {}
}
